(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = initAdmin

var createController = require('./controllers/controller')

function initAdmin () {
  return { festivalAdmin: init }
}

function init (serviceLocator, done) {

  createController(serviceLocator)
  done()
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/festival/init.js","/components/admin/festival")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvYWRtaW4vZmVzdGl2YWwvaW5pdC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsibW9kdWxlLmV4cG9ydHMgPSBpbml0QWRtaW5cblxudmFyIGNyZWF0ZUNvbnRyb2xsZXIgPSByZXF1aXJlKCcuL2NvbnRyb2xsZXJzL2NvbnRyb2xsZXInKVxuXG5mdW5jdGlvbiBpbml0QWRtaW4gKCkge1xuICByZXR1cm4geyBmZXN0aXZhbEFkbWluOiBpbml0IH1cbn1cblxuZnVuY3Rpb24gaW5pdCAoc2VydmljZUxvY2F0b3IsIGRvbmUpIHtcblxuICBjcmVhdGVDb250cm9sbGVyKHNlcnZpY2VMb2NhdG9yKVxuICBkb25lKClcbn1cbiJdfQ==